import { useMutation } from "@tanstack/react-query";
import estimateProvider from "@/providers/estimate.provider";
import type { PDFPreviewData } from "@rebuild/shared";

const EXPORT_PDF_KEY = ["pdfExport", "export"] as const;

export function useExportPDFMutation() {
  return useMutation({
    mutationKey: EXPORT_PDF_KEY,
    mutationFn: (params: { estimateId: string; pdfPreviewData: PDFPreviewData; filename?: string; sendToJobNimbus?: boolean }) =>
      estimateProvider.exportTo1Pager(params.estimateId, params.pdfPreviewData, params.filename, params.sendToJobNimbus),
  });
}
